/** A callback cannot live in the store, so a toast holds a key to one here. */
export const UNDO_WINDOW_MS = 8000;

const actions = new Map<string, () => void>();
let nextId = 0;

export function registerNotificationAction(action: () => void): string {
  nextId += 1;
  const id = `notification-action-${nextId}`;
  actions.set(id, action);
  return id;
}

export function runNotificationAction(id: string) {
  const action = actions.get(id);
  actions.delete(id);
  action?.();
}
